import { z } from 'zod';
import { Lookup } from './typeUtils';

/**
 * As agreed with Wellhub, `content_view` is the one billable event type, so
 * every usage event is a `content_view` with a subcategory saying what the
 * member did.
 */
const GYMPASS_EVENT_SUBCATEGORIES = ['workout', 'routine', 'user_profile'] as const;

export type GympassEventSubcategory = Lookup<typeof GYMPASS_EVENT_SUBCATEGORIES>;

/** @public Used again once the workout event in afterWorkoutSave is re-enabled. */
export const GYMPASS_EVENT_MAX_DURATION_MINS = 500;

const GympassClientEventSchema = z
  .object({
    event_type: z.literal('content_view'),
    event_subcategory: z.enum(GYMPASS_EVENT_SUBCATEGORIES),
    timestamp: z.string().datetime({ offset: true }),
    event_duration: z.number().int().min(0).max(GYMPASS_EVENT_MAX_DURATION_MINS).optional(),
  })
  .strict();

export const GYMPASS_EVENTS_MAX_BATCH_SIZE = 200;

export const PostGympassEventsRequestSchema = z
  .object({
    events: z.array(GympassClientEventSchema).min(1).max(GYMPASS_EVENTS_MAX_BATCH_SIZE),
  })
  .strict();

export type PostGympassEventsRequest = z.infer<typeof PostGympassEventsRequestSchema>;
